import React, { PureComponent } from 'react';

import { Card } from 'components/card';

import FileUploadingFailed from './FileUploadingFailed';

export default class FileCardUploadingFailed extends PureComponent {
  render() {
    return (
      <Card className="file__card">
        <FileUploadingFailed {...this.props} />
      </Card>
    );
  }
}
